export function readModelPreference(chatId: string | null, fallback: string): string {
  try {
    return chatId ? (localStorage.getItem(`chat-model-${chatId}`) ?? fallback) : fallback
  } catch {
    return fallback
  }
}

export function readEffortPreference<TFallback extends string | null>(chatId: string | null, fallback: TFallback): string | TFallback {
  try {
    return chatId ? (localStorage.getItem(`chat-effort-${chatId}`) ?? fallback) : fallback
  } catch {
    return fallback
  }
}

export function readContainerPreference(chatId: string | null, fallback: boolean): boolean {
  try {
    if (!chatId) return fallback
    const stored = localStorage.getItem(`chat-container-${chatId}`)
    return stored === null ? fallback : stored === 'true'
  } catch {
    return fallback
  }
}
